import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'vb-search-input',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './vb-search-input.component.html',
  styleUrls: ['./vb-search-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.Emulated
})
export class VbSearchInputComponent {
  private translateService = inject(TranslateService);

  @Input() placeholder = 'SEARCH';
  @Input() value = '';
  @Input() disabled = false;
  @Input() showClearButton = true;
  @Input() debounceTime = 0;
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() fullWidth = false;

  @Output() valueChange = new EventEmitter<string>();
  @Output() searchTriggered = new EventEmitter<string>();
  @Output() cleared = new EventEmitter<void>();

  private debounceTimer: any;

  onInputChange(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.value = inputValue;
    this.valueChange.emit(this.value);

    if (this.debounceTime > 0) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.searchTriggered.emit(this.value);
      }, this.debounceTime);
    } else {
      this.searchTriggered.emit(this.value);
    }
  }

  onClear(): void {
    this.value = '';
    this.valueChange.emit(this.value);
    this.searchTriggered.emit(this.value);
    this.cleared.emit();
  }

  get containerClasses(): string {
    const classes = ['vb-search'];
    classes.push(`vb-search--${this.size}`);
    if (this.fullWidth) classes.push('vb-search--full-width');
    if (this.disabled) classes.push('vb-search--disabled');
    return classes.join(' ');
  }

  get translatedPlaceholder(): string {
    return this.translateService.instant(this.placeholder);
  }
}
